import type { RootState } from '..';

export const selectKdsSelectedDepartmentId = (state: RootState) =>
  state.kds.selectedDepartmentId;
export const selectKdsIsMuted = (state: RootState) => state.kds.isMuted;
export const selectKdsDepartments = (state: RootState) => state.kds.departments;
export const selectKdsTickets = (state: RootState) => state.kds.tickets;
export const selectKdsKpis = (state: RootState) => state.kds.kpis;
export const selectKdsIsLoading = (state: RootState) => state.kds.isLoading;
export const selectKdsError = (state: RootState) => state.kds.error;
